export const socialLinks = [
  { label: 'LinkedIn', value: 'Matheus V. Costa', href: 'https://www.linkedin.com/in/matheus-vin%C3%ADcius-costa-127666189/' },
  { label: 'GitHub', value: 'matchur', href: 'https://github.com/matchur' },
  { label: 'Instagram', value: '@m4tchur', href: 'https://www.instagram.com/m4tchur/' },
];

export const contactLinks = [
  { label: 'Whatsapp', value: 'Link', href: 'https://api.whatsapp.com/send?phone=5518982028260' },
  { label: 'E-mail', value: 'ma.usv@hotmail.com', href: 'mailto:ma.usv@hotmail.com' },
  ...socialLinks,
];
